/* Social Viola: interakcje */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function onVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, { threshold: .25 }).observe(el);
  }
  function stepper(root, count, render, auto) {
    var cur = 0, timer = null, manual = false, visible = false;
    function go(i) { cur = (i + count) % count; render(cur); }
    function tick() { if (!manual && visible) go(cur + 1); }
    if (auto && !reduce) { timer = setInterval(tick, 2800); onVisible(root, function (v) { visible = v; }); }
    go(0);
    return { pick: function (i) { manual = true; go(i); } };
  }

  // okrąg metody
  document.querySelectorAll('[data-sv-ring]').forEach(function (root) {
    var labs = [].slice.call(root.querySelectorAll('.sv-ring__lab'));
    var dots = [].slice.call(root.querySelectorAll('.sv-ring__dot'));
    var chips = [].slice.call(root.querySelectorAll('.sv-ring__chips button'));
    var cNum = root.querySelector('[data-ring-num]'), cName = root.querySelector('[data-ring-name]'), cDesc = root.querySelector('[data-ring-desc]'), cBox = root.querySelector('[data-ring-box]');
    var s = stepper(root, labs.length, function (i) {
      [labs, dots, chips].forEach(function (arr) { arr.forEach(function (el, j) { el.classList.toggle('is-on', i === j); if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', i === j ? 'true' : 'false'); }); });
      cNum.textContent = ('0' + (i + 1)).slice(-2);
      cName.textContent = labs[i].dataset.name;
      cDesc.textContent = labs[i].dataset.desc;
      cBox.classList.remove('sv-fade'); void cBox.offsetWidth; cBox.classList.add('sv-fade');
    }, root.dataset.auto === 'true');
    labs.concat(chips).forEach(function (b) { b.addEventListener('click', function () { s.pick(parseInt(b.dataset.i, 10)); }); });
  });

  // droga współpracy
  document.querySelectorAll('[data-sv-road]').forEach(function (root) {
    var steps = [].slice.call(root.querySelectorAll('.sv-road__step'));
    var dots = [].slice.call(root.querySelectorAll('.sv-road__dot'));
    var line = root.querySelector('.sv-road__line');
    var s = stepper(root, steps.length, function (i) {
      steps.forEach(function (el, j) { el.classList.toggle('is-on', i === j); el.classList.toggle('is-past', j < i); el.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
      dots.forEach(function (el, j) { el.classList.toggle('is-on', i === j); el.classList.toggle('is-past', j < i); });
      if (line) line.style.strokeDashoffset = 100 - parseFloat(steps[i].dataset.f || '0');
    }, root.dataset.auto === 'true');
    steps.forEach(function (b, j) { b.addEventListener('click', function () { s.pick(j); }); });
  });

  // opinie wideo
  document.querySelectorAll('.sv-vid').forEach(function (box) {
    var v = box.querySelector('video'), b = box.querySelector('.sv-vid__play');
    if (!v || !b) return;
    b.addEventListener('click', function () {
      document.querySelectorAll('.sv-vid.is-playing video').forEach(function (o) { if (o !== v) o.pause(); });
      box.classList.add('is-playing'); v.controls = true; v.muted = false; v.play();
    });
  });

  // katalog programów
  document.querySelectorAll('[data-sk-catalog]').forEach(function (root) {
    var uid = root.dataset.user, cards = [].slice.call(root.querySelectorAll('.sk-card[data-course]'));
    var go = 0, fin = 0, sumPct = 0, open = 0, firstGo = null;
    cards.forEach(function (card) {
      var h = card.dataset.course, done = {}, total = 0;
      try { done = JSON.parse(ls('sk:' + h + ':' + uid) || '{}') || {}; total = parseInt(ls('skt:' + h) || '0', 10); } catch (e) {}
      var n = Object.keys(done).length, pct = total ? Math.min(100, Math.round(n / total * 100)) : 0;
      open++; sumPct += pct;
      card.querySelector('.sk-bar i').style.width = pct + '%';
      card.querySelector('.sk-pct').textContent = pct + '%';
      var t = card.querySelector('.sk-go span'), b = card.querySelector('.sk-badge');
      card.dataset.state = 'new';
      if (pct >= 100) { t.textContent = 'Obejrzyj ponownie'; b.textContent = 'Ukończony'; b.className = 'sk-badge is-done'; card.classList.add('is-complete'); card.dataset.state = 'done'; fin++; }
      else if (n > 0) { t.textContent = 'Kontynuuj'; b.textContent = 'W trakcie'; b.className = 'sk-badge is-go'; card.dataset.state = 'go'; go++; if (!firstGo) firstGo = card; }
    });
    var setT = function (sel, v) { var el = root.querySelector(sel); if (el) el.textContent = v; };
    setT('[data-n-done]', fin); setT('[data-n-all]', open);
    setT('[data-n-pct]', open ? Math.round(sumPct / open) : 0);
    var nodes = [].slice.call(root.querySelectorAll('.sk-way__node'));
    nodes.forEach(function (nd) {
      var c = root.querySelector('.sk-card[data-course="' + nd.dataset.course + '"]');
      if (!c) return;
      if (c.dataset.state === 'done') nd.classList.add('is-done');
      else if (c === firstGo) nd.classList.add('is-now');
    });
    var hello = root.querySelector('[data-continue]');
    if (hello && firstGo) {
      hello.querySelector('[data-continue-name]').textContent = firstGo.dataset.name;
      hello.querySelector('a').href = firstGo.href; hello.hidden = false;
      var def = root.querySelector('[data-continue-default]'); if (def) def.hidden = true;
    }
    var fbtn = [].slice.call(root.querySelectorAll('.sk-filters button'));
    fbtn.forEach(function (b) { b.addEventListener('click', function () {
      fbtn.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var f = b.dataset.f;
      root.querySelectorAll('.sk-card').forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.state === f); });
    }); });
  });

  // lekcje
  document.querySelectorAll('[data-sk-course]').forEach(function (root) {
    var lessons = [].slice.call(root.querySelectorAll('.sk-lesson'));
    var items = [].slice.call(root.querySelectorAll('.sk-item'));
    if (!lessons.length) return;
    var course = root.dataset.course, key = 'sk:' + course + ':' + root.dataset.user;
    var done = {}; try { done = JSON.parse(ls(key) || '{}') || {}; } catch (e) {}
    var ids = {}; lessons.forEach(function (l) { ids[l.dataset.id] = 1; });
    Object.keys(done).forEach(function (k) { if (!ids[k]) delete done[k]; });
    function save() { ls(key, JSON.stringify(done)); ls('skt:' + course, String(lessons.length)); }
    save();
    var cur = 0, side = root.querySelector('.sk-side'), ring = root.querySelector('.sk-ring__val');
    function render() {
      var n = 0; lessons.forEach(function (l) { if (done[l.dataset.id]) n++; });
      var pct = Math.round(n / lessons.length * 100);
      if (ring) ring.style.strokeDashoffset = 207.3 * (1 - pct / 100);
      root.querySelectorAll('[data-pct]').forEach(function (e) { e.textContent = pct + '%'; });
      root.querySelectorAll('[data-count]').forEach(function (e) { e.textContent = n + ' z ' + lessons.length + ' lekcji ukończone'; });
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === cur); it.classList.toggle('is-done', !!done[lessons[i].dataset.id]); it.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      lessons.forEach(function (l) { l.querySelector('.sk-done').classList.toggle('is-done', !!done[l.dataset.id]); });
    }
    function show(i, scroll) {
      if (i < 0 || i >= lessons.length) return;
      lessons.forEach(function (l, j) {
        var f = l.querySelector('iframe');
        if (j === i) { l.hidden = false; if (f && !f.getAttribute('src')) f.setAttribute('src', f.dataset.src); }
        else { l.hidden = true; if (f && f.getAttribute('src')) f.removeAttribute('src'); }
      });
      cur = i;
      try { history.replaceState(null, '', '#lekcja-' + (i + 1)); } catch (e) {}
      render();
      if (side) side.classList.remove('is-open');
      if (scroll) root.querySelector('.sk-main').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    items.forEach(function (it, i) { it.addEventListener('click', function () { show(i, window.innerWidth < 900); }); });
    lessons.forEach(function (l, i) {
      l.querySelector('.sk-prev').addEventListener('click', function () { show(i - 1, true); });
      l.querySelector('.sk-next').addEventListener('click', function () { show(i + 1, true); });
      l.querySelector('.sk-done').addEventListener('click', function () { var id = l.dataset.id; if (done[id]) delete done[id]; else done[id] = 1; save(); render(); });
    });
    var tog = root.querySelector('.sk-toggle');
    if (tog) tog.addEventListener('click', function () { var o = side.classList.toggle('is-open'); tog.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    var m = (location.hash || '').match(/lekcja-(\d+)/);
    show(m ? Math.min(parseInt(m[1], 10) - 1, lessons.length - 1) : 0, false);
    document.addEventListener('shopify:block:select', function (e) { var idx = lessons.findIndex(function (l) { return l.contains(e.target); }); if (idx > -1) show(idx, false); });
  });
})();
/* poprawka: film w lekcji (edytor motywu + YouTube referrer) */ (function(){function fix(s){(s||document).querySelectorAll('.sk-lesson:not([hidden]) iframe[data-src]').forEach(function(f){f.setAttribute('referrerpolicy','strict-origin-when-cross-origin');f.removeAttribute('loading');f.setAttribute('src',f.getAttribute('data-src'));});}fix();document.addEventListener('shopify:section:load',function(e){fix(e.target);});})();